import { events } from "@constants/tracking";
import { useArticles } from "@features/articles/hooks/useArticles";
import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { getDisplayName } from "@helpers/user";
import useAnalytics from "@hooks/useAnalytics";
import { titleCase } from "@memorang/helpers/common";
import Box from "@memorang/ui/components/Box";
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";
import Loader from "@memorang/ui/components/Loader";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { trackCustomEvent } from "analytics";
import { useNavigation } from "expo-router";
import ImageChallengeHomeView from "../components/ImageChallengeHomeView";
import { useImageChallengeHome } from "../hooks/useImageChallengeHome";

const ImageChallengeHomeContainer = () => {
	const { featuredChallenge, imageChallengeHomeSectionList, isLoading } =
		useImageChallengeHome();
	const navigation = useNavigation<{ toggleDrawer?: () => void }>();

	const { userInfo, firstName, lastName } = useAuthContext();

	const { explicitCallTrackCustomEvent } = useAnalytics();

	const { handleNavigateToArticle } = useArticles();
	const handleClickCard = (id: number, type: string, isFeatured?: boolean) => {
		switch (type) {
			case "article": {
				explicitCallTrackCustomEvent({
					eventName: events.articleClicked,
					articleId: id,
					source: "home",
				});
				handleNavigateToArticle(id);
				break;
			}
			case "challenge": {
				const eventName = isFeatured
					? events.featuredChallengeClicked
					: events.challengeClicked;
				explicitCallTrackCustomEvent({
					eventName,
					challengeId: id,
					source: "home",
				});
				break;
			}
			default:
				break;
		}
	};

	const getGreeting = () => {
		const currentHour = new Date().getHours();
		if (currentHour < 12) {
			return "☀️ Good morning";
		}
		if (currentHour < 18) {
			return "🌇️ Good afternoon";
		}
		return "🌙 Good evening";
	};

	const greeting = getGreeting();

	const displayName = getDisplayName(userInfo?.profession, firstName, lastName);
	const appbarTitle = displayName
		? `${greeting}, ${titleCase(displayName)}`
		: `${greeting}!`;

	return (
		<>
			<CustomAppBar
				title={appbarTitle}
				navigation={navigation}
				handleTrackEvent={() => {
					trackCustomEvent({
						eventName: events.commandBarClicked,
						option: "command_bar",
					});
				}}
			/>
			<ScrollContainer maxWidth="sm">
				{isLoading ? (
					<Box
						alignItems="center"
						justifyContent="center"
						flexGrow={1}
						height="100%"
					>
						<Loader />
					</Box>
				) : (
					<Box paddingTop={8} paddingBottom={8}>
						<ImageChallengeHomeView
							recommendedChallenge={featuredChallenge}
							isPremiumUser={false}
							imageChallengeHomeSectionList={imageChallengeHomeSectionList}
							handleClickCard={handleClickCard}
						/>
					</Box>
				)}
			</ScrollContainer>
		</>
	);
};

export default ImageChallengeHomeContainer;
